module.exports = __webpack_public_path__ + "static/img/towel.366a5dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/suspect/images/goods/towel.png
// module id = fxA2
// module chunks = 1